<template>
	<div class="app">
		<div v-if="!$auth.ready()">Veuillez patienter...</div>

		<div v-if="$auth.ready()">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'App',
	};
</script>

<style lang="scss">
	// Import Main styles for this application
	@import 'assets/scss/style';
</style>
